import classNames from "classnames";
import { useCallback, useState } from "react";
import AscButton from "../../AscButton/AscButton";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscNoteCard.module.scss";
import dayjs from "dayjs";
import { NotePlayIcon } from "../../AscIcons";
import AscRichTextEditor from "../../AscRichTextEditor/AscRichTextEditor";

export interface AscNoteCardProps {
  date: string;
  initialValue?: string;
  disabled?: boolean;
  loading?: boolean;
  onAddToJournal?: (value: string) => void;
  className?: string;
}

export default function AscNoteCard({
  date,
  onAddToJournal,
  className,
  initialValue,
  loading = false,
  disabled = false,
}: AscNoteCardProps) {
  const [jsonString, setJsonString] = useState("");

  const onChange = useCallback((json: string) => {
    setJsonString(json);
  }, []);

  function onAddToJournalClick() {
    onAddToJournal?.(jsonString);
  }

  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      imageClassName={styles.cardImage}
      title={null}
      coverImageUrl={null}
      bodyClassName={styles.body}
      contentClassName={styles.content}
      footer={
        <div className={styles.footer}>
          <div className={styles.date}>{dayjs(date).format("DD/MM/YYYY")}</div>
          <AscButton
            loading={loading}
            disabled={disabled}
            onClick={onAddToJournalClick}
            size="small"
          >
            Add to journal
          </AscButton>
        </div>
      }
    >
      <AscRichTextEditor
        //might not be json so infer type
        initialInferValue={initialValue}
        editable={!loading && !disabled}
        disableAutoFocus={true}
        
        header={
          <div className={styles.editorHeader}>
            <NotePlayIcon className={styles.playIcon} />
            <div className={styles.editorHeaderTitle}>
              Make some notes from the video
            </div>
          </div>
        }
        bodyClassName={styles.editorBody}
        inputWrapperClassname={styles.editorInput}
        headerPosition="bottom"
        toolbarBorder={false}
        onJsonChange={onChange}
        toolbarOptions={{
          blockType: false,
          orderedList: false,
        }}
      />
    </AscGenericCard>
  );
}
